import React from 'react';

import { Button, Chip, FormControlLabel, MenuItem, Select, Stack, Switch } from '@mui/material';

import { CommandFilters } from './logic';
import { queueCodes, reviewStatuses } from './reviewLogic';

export default function ReviewControls({
  filters,
  onChange,
  overview = false,
}: {
  filters: CommandFilters;
  onChange: (changes: Partial<CommandFilters>) => void;
  overview?: boolean;
}) {
  return (
    <Stack gap={1} sx={{ my: 1 }}>
      <Stack direction="row" flexWrap="wrap" alignItems="center" gap={1}>
        <FormControlLabel
          label="In review (240 days)"
          control={<Switch checked={filters.inReview} onChange={(e) => onChange({ inReview: e.target.checked })} />}
        />
        <Select
          size="small"
          value={filters.reviewStatus ?? 'all'}
          inputProps={{ 'aria-label': 'Review status' }}
          onChange={(e) => onChange({ reviewStatus: e.target.value })}
        >
          <MenuItem value="all">All review statuses</MenuItem>
          {reviewStatuses.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
        <Select
          size="small"
          value={filters.reviewSort ?? 'priority'}
          inputProps={{ 'aria-label': 'Review sort' }}
          onChange={(e) => onChange({ reviewSort: e.target.value })}
        >
          <MenuItem value="priority">Priority</MenuItem>
          <MenuItem value="longest">Longest at status</MenuItem>
        </Select>
        <Chip
          label="Sell-out watch"
          variant={filters.sellOut ? 'filled' : 'outlined'}
          onClick={() => onChange({ sellOut: !filters.sellOut })}
        />
        {overview && (
          <Button
            size="small"
            variant={filters.rmReview ? 'contained' : 'outlined'}
            onClick={() =>
              onChange({
                rmReview: !filters.rmReview,
                inReview: true,
                reviewSort: 'priority',
                reviewStatus: 'all',
                action: 'all',
                onlyAttention: false,
              })
            }
          >
            RM review
          </Button>
        )}
      </Stack>
      {overview && (
        <Stack direction="row" flexWrap="wrap" gap={0.5}>
          {Object.keys(queueCodes).map((queue) => (
            <Chip
              size="small"
              key={queue}
              label={queue}
              variant={filters.queue === queue ? 'filled' : 'outlined'}
              onClick={() => onChange({ queue: filters.queue === queue ? null : queue })}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
